import {Component, Directive, Module} from 'app/decorators';
import ProductStore from 'app/stores/product';

import BasePicker from './base.picker';
import tpl from './product.picker.html';


@Module({
    name: "app.directives.productpicker",
    modules: [
        ProductStore,
    ],

})
@Component({
    selector: 'blnd-product-picker',
    bindings: {
        ngModel: '=',
        onChange: '&',
        mode: '@?',
        placeholder: '@?',
        extendedClassStyleName: '@?',
        extraFields: '<',
        crop: '<?',
        company: '<?',
        customer: '<?',
        focus: '=?',
        forceUpdate: '<?',
        isActive: '@?',
    },
    template: tpl,
})
export default class C extends BasePicker {
    constructor ($scope, $element, $timeout, ProductStore) {
        "ngInject";
        super($element);
        let defaultFields = ['id', 'title', 'units', 'is_active'];

        this.scope = $scope;
        this.store = ProductStore;
        this.$timeout = $timeout;
        this.store.init();
        if (_.isUndefined(this.isActive)) {
            this.store.params.is_active = "True";
        } else if (this.isActive !== '') {
            this.store.params.is_active = {"": undefined, true: "True", false: "False"}[this.isActive];
        }

        let extraFields = (_.isUndefined(this.extraFields) ? [] : this.extraFields);
        this.store.params.field = _.concat(defaultFields, extraFields);
        this.store.params.extra_field =  extraFields;
        if (!_.isUndefined(this.company)) {
            this.store.params.company = this.company.id;
        }

        if (!_.isUndefined(this.customer)) {
            this.store.params.customer = this.customer.id;
            this.store.params.price_level = this.customer.price_level;
        }

        if (!_.isUndefined(this.crop) && _.has(this.crop, 'id')) {
            this.store.params.crop = this.crop.id;
        }

        this.mode = this.mode || 'view';
        this.forceUpdate = this.forceUpdate || false;
    }

    hasValue (obj, name) {
        if (obj[name] && obj[name].isFirstChange && obj[name].isFirstChange()) {
            return false;
        }
        return obj[name] && obj[name].currentValue && obj[name].currentValue.id;
    }

    $postLink ()  {
        let self = this;
        if (!this.forceUpdate) {
            return
        }

        if (self.ngModel && self.ngModel.id) {
            self.store.get(self.ngModel.id, self.store.params).then((response) => {
                self.ngModel = response;
                self.forceUpdate = false;
            });
        }

    }

    $onChanges (changesObj) {
        if (this.hasValue(changesObj, 'company')) {
            this.store.params.company = changesObj.company.currentValue.id;
        }
        if (this.hasValue(changesObj, 'crop')) {
            this.store.params.crop = changesObj.crop.currentValue.id;
            this.store.refresh()
        }
        if (this.hasValue(changesObj, 'customer')) {
            this.store.params.customer = changesObj.customer.currentValue.id;
        }
    }

    onSelect ($item, $model) {
        if (this.onChange) {
            this.onChange();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/directives/product.picker.js